import {Dialog} from '@mui/material';
import {ItemStatus} from 'models/board';
import {ItemDataResponse} from 'models/board/itemData';
import React from 'react';
import BoardItemDialog from './BoardItemDialog';

export interface BoardItemDrawerProps {
    open: boolean;
    handleDrawerClose: () => void;
    removeItemDataFromState: (id: string) => void;
    handleUpdateItemDataState: (ItemDataModel: ItemDataResponse) => void;
    itemStatuses?: ItemStatus[];
    getItemDataByIdLoading: boolean;
    getItemDataByIdResponse: ItemDataResponse;
    getItemDataById: () => void;
    boardId: string;
}

export const BoardItemDrawer: React.FC<BoardItemDrawerProps> = ({open, ...rest}) => {
    return (
        <>
            {open && (
                <Dialog
                    fullWidth
                    maxWidth="xl"
                    sx={{
                        '& .MuiDialog-paper': {
                            height: 'calc(100% - 64px)',
                            overflow: 'hidden',
                        },
                    }}
                    open={open}
                    // onClose={handleDialogClose}
                >
                    <BoardItemDialog open={open} {...rest} />
                </Dialog>
            )}
        </>
    );
};

export default BoardItemDrawer;
